import {
  Col,
  Form,
  Row
} from "react-bootstrap";
import {
  useState
} from "react";
import { useTranslation } from 'react-i18next';
import { Button, Modal } from "react-bootstrap";

export const ModalCopy = (props: any) => {
  const [equipmentCode, setEquipmentCode] = useState<string>()
  const [addHistory, setAddHistory] = useState<boolean>()
  const { t } = useTranslation();
  return (
    <>
      <Modal as={Modal.Dialog} 
        centered show={props.show} 
        onHide={props.close} 
        onShow={() => {setEquipmentCode(''); setAddHistory(false)}}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="align-items-center">
              <Col xs="5">
                {t('EQUIPMENT.COPY_REFERENCE')}
              </Col>
              <Col xs="6">
                <Form.Group>
                  <Form.Control style={{ display: 'none' }} ></Form.Control>
                  <Form.Floating>
                    <Form.Control
                      name='code_equipment'
                      id='code_equipment'
                      type='text'
                      className='form-control'
                      disabled={true}
                      value={props.Message}/>
                  </Form.Floating>
                </Form.Group>
              </Col>
            </Row>
            <br></br>
            <Row className="align-items-center">
              <Col xs="5">
                {t('EQUIPMENT.COPY_DETAIL')}
              </Col>
              <Col xs="6">
                <Form.Group>
                  <Form.Control style={{ display: 'none' }} ></Form.Control>
                  <Form.Floating>
                    <Form.Control
                      name='code_equipment'
                      id='code_equipment_copy'
                      type='text'
                      maxLength={50}
                      placeholder={t(`EQUIPMENT.CODE_EQUIPMENT`)}
                      className='form-control'
                      onChange={(event) => {setEquipmentCode(event.target.value)}}
                      value={equipmentCode}/>
                    <label htmlFor="code_equipment">{t("EQUIPMENT.CODE_EQUIPMENT")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>
            </Row>  
            <br></br>
            <Row className="align-items-center">
              <Col xs="5">
                <Form.Group>                
                  <Form.Check
                    inline
                    id='add_history'
                    label={t('ADD_HISTORY')}
                    disabled={false}
                    name='add_history'
                    type='checkbox'
                    onChange={() => {setAddHistory(!addHistory)}}                    
                    checked={addHistory}
                  />
                </Form.Group>
              </Col>
            </Row> 
            <br></br>   
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ marginLeft: "auto" }}>
          <Button
            variant='primary'
            style={{ marginLeft: "auto" }}
            className='text-gray ms-auto'
            onClick={() => {setEquipmentCode(''); setAddHistory(false)}}>
            {t('CLEAR')}
          </Button>
          <Button
            variant='primary'
            style={{ marginLeft: "auto" }}
            className='text-gray ms-auto'
            onClick={() => {props.copy(equipmentCode, addHistory)}}>
            {t('COPY')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
